// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"988d109a","99":"d28b5fc3","187":"37257816","261":"e540b47f","384":"e34709c0","453":"fb69feec","736":"6cd35063","785":"ec586c79","867":"151ce23e","942":"4e58e8b5"}[chunkId] + ".chunk.js";
};